import { render, staticRenderFns } from "./BaseInput.vue?vue&type=template&id=16f9e879&"
import script from "./BaseInput.vue?vue&type=script&lang=ts&"
export * from "./BaseInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports